import Cookies from 'js-cookie';

export interface IOptions {
    expires?: number | Date | undefined,
    path?: string | undefined,
    domain?: string | undefined,
    secure?: boolean | undefined,
    sameSite?: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None' | undefined,
    [property: string]: unknown
}

export const get = (name: string) => Cookies.get(name);

export const has = (name: string) => !!get(name);

export const getAll = () => Cookies.get();

export const set = (name: string, value: string, options?: IOptions) => Cookies.set(name, value, options);

export const remove = (name: string, options?: IOptions) => Cookies.remove(name, options);
